import { Form, Input, Modal } from 'antd';
import { useEffect, useState } from 'react';

export interface VersionInfoType {
  name: string;
  description?: string;
}

export interface VersionInfoModalProps {
  open: boolean;
  onConfirm: (info: VersionInfoType) => void;
  onClose: () => void;
}

const VersionInfoModal = ({
  open,
  onClose,
  onConfirm,
}: VersionInfoModalProps) => {
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');

  const handleOk = () => {
    onConfirm({
      name,
      description,
    });
  };

  useEffect(() => {
    setName(open ? `Version - ${new Date().toISOString()}` : '');
    setDescription('');
  }, [open]);

  return (
    <Modal
      open={open}
      title="Version Info"
      onCancel={onClose}
      onClose={onClose}
      onOk={handleOk}
    >
      <Form layout="vertical">
        <Form.Item label="Version Name">
          <Input
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Please input version name"
            allowClear
          />
        </Form.Item>
        <Form.Item label="Description">
          <Input.TextArea
            value={description}
            placeholder="Please input description"
            onChange={(e) => setDescription(e.target.value)}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default VersionInfoModal;
